module.exports = __webpack_public_path__ + "static/media/chevron.3c858374.svg";